// extracted by mini-css-extract-plugin
export default {"overlay":"cardLoading_overlay__7vV8+","card":"cardLoading_card__voLej","sizeIcon":"cardLoading_sizeIcon__dJ13k"};